module.exports = __webpack_public_path__ + "static/media/news.b5f19e77.svg";